import React from "react";
import SC from "./style";
import InnoIcons from "@InnoIcons/";

const DrawerHeader = (props) => {
  const { title, onClose, actions } = props;

  return (
    <SC.DrawerTitlesContainer>
      <SC.DrawerTitles>
        <span>{title}</span>
      </SC.DrawerTitles>

      <SC.CloseIcon>
        {actions}
        {onClose && <InnoIcons.CloseIcon onClick={onClose} />}
      </SC.CloseIcon>
    </SC.DrawerTitlesContainer>
  );
};

export default DrawerHeader;
